
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiEventMarkerIec as ObiEventMarkerIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-event-marker-iec.js';
 
 
 

 
 export const ObiEventMarkerIec = createComponent({
   react: React,
   tagName: 'obi-event-marker-iec',
   elementClass: ObiEventMarkerIecElement,
   events: {
     
   }
  });
 
 